import { createSlice } from "@reduxjs/toolkit";

// Controls navbar-highlight state and the notification panel visibility.
const navbarSlice = createSlice({
  name: "activeClass",
  initialState: {
    activeClassName: "dashboard",
    openNotificationPanel: false,
  },
  reducers: {
    // Track the currently active sidebar/navbar route for UI highlighting.
    addActiveClass: (state, action) => {
      state.activeClassName = action.payload;
    },
    // Open or close the notification drawer from anywhere in the app.
    updateOpenNotificationPanel: (state, action) => {
      state.openNotificationPanel = action.payload;
    },
  },
});

export const { addActiveClass, updateOpenNotificationPanel } =
  navbarSlice.actions;

export default navbarSlice.reducer;
